import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPrioritizedRelation } from 'components/ArtboardAssets/Text/utils/relation';
import * as Constants from 'const';
import { referenceCitationsOrderByDocuments } from 'containers/Documents/selectors';
import * as Models from 'models';
import { getReferencesMap } from '../utils/getReferencesMap';

export function useReferencesMap(
  document: Models.TextComponentMap | undefined,
  relation: Models.LayeredRegularRelationMap<Models.TextRelationStyles>,
  activeLayer: Constants.Layer,
): Record<string, number> {
  const referencesOrder = useSelector(referenceCitationsOrderByDocuments);

  return useMemo(() => {
    const prioritizedRelation = getPrioritizedRelation({ relation, activeLayer });

    return getReferencesMap(
      referencesOrder,
      document?.get('referenceCitations')?.toJS() ?? [],
      prioritizedRelation.get('id'),
      prioritizedRelation.get('documentId'),
    );
  }, [document, relation, activeLayer, referencesOrder]);
}
